import { Card, message, Tag } from "antd";
import { CreditCard, Headphones, Shield } from "lucide-react";
import styled, { keyframes } from "styled-components";
import { RocketOutlined } from "@ant-design/icons";
import apiClient from 'services/apiClient';

// Keyframes for animation
export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
];
`;

export const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
`;

// Styled Components for Animations
export const AnimatedCard = styled(Card)`
  animation: ${fadeIn} 0.6s ease-out;
  transition: all 0.25s ease-in-out;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
`;

export const FloatingIcon = styled.div`
  animation: ${float} 3s ease-in-out infinite;
  display: flex;
  justify-content: center;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: #00c853;
  margin: 0 auto 16px;
  box-shadow: 0 4px 10px rgba(0, 200, 83, 0.2);
`;

export const DescriptionFeatures = [
    {
        icon: <RocketOutlined style={{ fontSize: 32, color: "#00c853" }} />,
        title: "Lightning Fast",
        description: "Instant message delivery worldwide",
    },
    {
        icon: <Shield size={32} color="#00c853" />,
        title: "Secure & Reliable",
        description: "99.9% uptime with enterprise security",
    },
    {
        icon: (
            <Tag
                style={{
                    borderRadius: "50%",
                    padding: 0,
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: 0,
                }}
            >
                <CreditCard color="#00c853" size={33} />
            </Tag>
        ),
        title: "Flexible Billing",
        description: "Pay monthly or yearly with no hidden fees",
    },
    {
        icon: (
            <Tag
                style={{
                    borderRadius: "50%",
                    padding: 0,
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: 0,
                }}
            >
                <Headphones size={32} color="#00c853" />
            </Tag>
        ),
        title: "24/7 Support",
        description: "Expert help whenever you need it",
    },
];

// Fetch plans;
export const fetchPlans = async (api, setPlans) => {
    try {
        const response = await apiClient.get(`${api}plans`);

        if (response.data.success) {
            setPlans(response.data.data);
        }
    } catch (error) {
        const err = error.response.data;
        message.error(err.error || err.message || "Failed to fetch plans");
    }
};

export const handleFeatureChange = async (api, authToken, payload, values, setFeatures, features) => {
    const config = {
        headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
        }
    };
    const response = await apiClient.post(`${api}plan-features`, payload, config);

    // Add to local state with ID from response
    const newFeature = {
        id: response.data.data.id || features.length ? Math.max(...features.map(f => f.id)) + 1 : 1,
        name: values.name,
        description: values.description
    };
    setFeatures([...features, newFeature]);
    message.success('Feature added successfully');
}